
import React from "react";
import { motion } from "framer-motion";

export const WhatIsSelahSection = () => {
  return (
    <section className="py-16 md:py-24 bg-heaven-accent">
      <div className="container mx-auto px-4 max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-[#1A1F2C] mb-6">
            What Is Selah?
          </h2>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img 
              src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//about1.png" 
              alt="What is Selah" 
              className="rounded-xl shadow-lg w-full"
            />
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <p className="text-lg text-gray-700">
              Selah isn't just an app. It's a discipleship companion, an evangelism trainer, 
              a Scripture search engine, a prayer partner, and a truth-telling toolset, all in one.
            </p>
            
            <p className="text-lg text-gray-700">
              We built Selah for one reason: Because this generation is facing spiritual confusion 
              at a scale we've never seen, and they need truth that's accessible, clear, and unwavering.
            </p>
            
            <p className="text-xl italic text-heaven-gold font-medium text-center my-8">
              "We don't worship the tool, we serve the God who empowers it."
            </p>
            
            <p className="text-lg text-gray-700">
              Whether you're in a conversation with someone from another faith, wrestling with 
              cultural pressure, needing a Spirit-led prayer, or searching the Word for guidance, 
              Selah is there. 24/7.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
